import { openDB } from 'idb';

const DB_NAME = 'Bryemma_offline';
const STORE_NAME = 'pending_syncs';

/**
 * Inicializa la base de datos IndexedDB
 */
export const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
      }
    },
  });
};

/**
 * Agrega una tarea de sincronización a la cola
 */
export const queueSyncTask = async (type, data) => {
  const db = await initDB();
  await db.add(STORE_NAME, {
    type,
    data,
    timestamp: Date.now(),
    retryCount: 0
  });
  console.log(`[OfflineSync] Tarea ${type} encolada.`);
};

/**
 * Intenta procesar todas las tareas pendientes
 */
export const processPendingSyncs = async (handlers) => {
  const db = await initDB();
  
  // Get tasks in a separate read transaction
  const tasks = await db.getAll(STORE_NAME);

  for (const task of tasks) {
    const handler = handlers[task.type];
    if (handler) {
      try {
        await handler(task.data);
        // Delete in its own transaction to avoid auto-commit issues
        await db.delete(STORE_NAME, task.id);
        console.log(`[OfflineSync] Tarea ${task.id} (${task.type}) procesada con éxito.`);
      } catch (err) {
        console.error(`[OfflineSync] Error procesando tarea ${task.id}:`, err);
        task.retryCount = (task.retryCount || 0) + 1;
        if (task.retryCount >= 5) {
          console.warn(`[OfflineSync] Tarea ${task.id} excedió límite de reintentos (5). Eliminando.`);
          await db.delete(STORE_NAME, task.id);
        } else {
          await db.put(STORE_NAME, task);
        }
      }
    }
  }
};
